import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CrudType, IApplicationResponse, ModulesBasedApiSuffix, RxjsService } from '@app/shared';
import { CrudService } from '@app/shared/services';
import { InventoryModuleApiSuffixModels } from '@modules/inventory';
import { WasteDisposalRequest } from '@modules/inventory/models/WasteDisposalRequest';
@Component({
  selector: 'app-inventory-staff-request-view',
  templateUrl: './inventory-staff-request-view.component.html',
  styleUrls: ['./inventory-staff.component.scss']
})
export class InventoryStaffRequestViewComponent implements OnInit {

  wdRequestId: string;
  wasteDisposalRequestDto: WasteDisposalRequest | any;
  selectedTabIndex = 0;
  primengTableConfigProperties;

  constructor(private activatedRoute: ActivatedRoute,
    private router: Router,
    private commonService: CrudService, private rxjsService: RxjsService) {
    this.wdRequestId = this.activatedRoute.snapshot.queryParams.id;
    this.primengTableConfigProperties = {
      tableCaption: "Waste Disposal View",
      breadCrumbItems: [{ displayName: 'Inventory Management', relativeRouterUrl: '' },
      { displayName: 'Waste Disposal List', relativeRouterUrl: '/inventory/waste-disposal/staff-request-list' },
      { displayName: 'Waste Disposal View', relativeRouterUrl: ''}],
      selectedTabIndex: 0,
      tableComponentConfigs: {
        tabsList: [
          {
            enableBreadCrumb: true,
            enableAction: true,
            enableEditActionBtn: true,
            enableClearfix: true,
          }]
      }
    }
  }

  ngOnInit(): void {
    this.wasteDisposalRequestDto = new WasteDisposalRequest();
    this.GetWasteDisposalById(this.wdRequestId);
  }

  GetWasteDisposalById(wdRequestId: string) {
    this.commonService.get(ModulesBasedApiSuffix.INVENTORY, InventoryModuleApiSuffixModels.WASTE_DISPOSAL_VIEW, wdRequestId, false, null).subscribe((response: IApplicationResponse) => {
      this.wasteDisposalRequestDto = response.resources;

      this.rxjsService.setGlobalLoaderProperty(false);
    });
  }
  onCRUDRequested(type: CrudType | string, row?: object, searchObj?: any): void {
    switch (type) {
      case CrudType.EDIT:
        this.navigateToEdit();
        break;
    }
  }
  navigateToEdit() {
    this.router.navigate(['/inventory/waste-disposal/staff-request-list/add-edit'], { queryParams: { id: this.wdRequestId } });
  }

  navigateToList() {
    this.router.navigate(['/inventory/waste-disposal/staff-request-list']);
  }
}
